import borysWebp from "./images/borys.webp";
import borysPng from "./images/borys.png";

import { ReactComponent as BorysQr } from "./images/borys-qr.svg";

export const contacts = [
  {
    images: {
      photo: {
        webp: borysWebp,
        png: borysPng,
      },
      qr: BorysQr,
    },
    firstName: "Borys",
    lastName: "Gurtovyi",
    title: "Founder, CEO at Agilistry",
    email: "bgurtovyi@agilistrysoft.com",
    work: { tel: "+13236756008", mask: "+1 (323) 675-6008" },
    mobile: { tel: "+380630543411", mask: "+380 (63) 054-3411" },
    linkedin: "https://www.linkedin.com/in/borys-gurtovyi-a3725b11a",
    telegram: "https://telegram.me/+380630543411",
    whatsapp: "https://wa.me/+380630543411",
    instagram: "https://instagram.com/booorisss?igshid=YmMyMTA2M2Y=",
    facebook: "https://www.facebook.com/profile.php?id=100001302259568",
    slug: "borys",
    website: "https://agilistrysoft.com/",
    text: [
      `As CEO of Agilistry and a senior engineer myself, I focus my energies on establishing a healthy technical environment in the company. By utilizing the newest technologies we have established the various instruments and technics on how to achieve the most optimal & efficient technical delivery to the client.`,
      `I hold a master’s degree in Computer Science from USC and enjoy teaching students to advance in their careers.
      `,
      `Check out what we have built for our customers by visiting <a href=https://agilistrysoft.com/cases >https://agilistrysoft.com/cases</a>`,
    ],
  },
];
